(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(73202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/components/Menu/FacebookIcon.tsx

var FacebookIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.0699 35.9391C27.8398 35.9391 35.7599 28.019 35.7599 18.2491C35.7599 8.47917 27.8398 0.559082 18.0699 0.559082C8.29999 0.559082 0.379913 8.47917 0.379913 18.2491C0.379913 28.019 8.29999 35.9391 18.0699 35.9391Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.225 8.87616H20.4132C19.1702 8.87616 17.9782 9.36991 17.0993 10.2488C16.2205 11.1277 15.7267 12.3197 15.7267 13.5626V16.3745H12.9148V20.1237H15.7267V27.622H19.4759V20.1237H22.2878L23.225 16.3745H19.4759V13.5626C19.4759 13.314 19.5746 13.0756 19.7504 12.8999C19.9262 12.7241 20.1646 12.6253 20.4132 12.6253H23.225V8.87616Z",
                fill: "#0A1C32",
                stroke: "#0A1C32",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Menu_FacebookIcon = (FacebookIcon);

;// CONCATENATED MODULE: ./src/components/Menu/TelegramIcon.tsx

var TelegramIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.7498 35.0593C27.2768 35.0593 34.9999 27.3362 34.9999 17.8092C34.9999 8.28222 27.2768 0.559082 17.7498 0.559082C8.22283 0.559082 0.499695 8.28222 0.499695 17.8092C0.499695 27.3362 8.22283 35.0593 17.7498 35.0593Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7989 11.2253C25.7254 11.6037 25.6542 11.9828 25.5779 12.3606C25.2211 14.1286 24.8633 15.8965 24.5046 17.6641C24.0836 19.7432 23.6627 21.822 23.2419 23.9006C23.1748 24.2323 23.1086 24.5643 23.0412 24.8963C23.0339 24.9322 23.024 24.9681 23.0145 25.0038C22.77 25.9234 22.0831 26.0268 21.4086 25.5463C20.3131 24.7659 19.2415 23.9525 18.1597 23.153C17.8913 22.9546 17.619 22.7603 17.3551 22.5571C17.2642 22.4871 17.2092 22.4976 17.1284 22.5765C16.5028 23.1868 15.8738 23.7938 15.2414 24.3973C15.1009 24.5339 14.9479 24.6571 14.7844 24.7653C14.4346 24.992 14.0426 24.9007 13.8568 24.5287C13.716 24.2466 13.6155 23.9426 13.5166 23.6418C13.0652 22.27 12.6184 20.8966 12.1759 19.5218C12.1365 19.3994 12.0757 19.3336 11.9485 19.2945C10.6747 18.9024 9.40458 18.502 8.13038 18.1071C7.90428 18.0371 7.70871 17.9328 7.6025 17.7093C7.45241 17.3938 7.58565 17.0195 7.94149 16.8227C8.13419 16.7162 8.34852 16.6471 8.55585 16.5683C11.9838 15.2694 15.4123 13.9711 18.8411 12.6735C20.7113 11.9654 22.5821 11.2586 24.4534 10.5531C24.6442 10.4812 24.8458 10.41 25.0462 10.3969C25.4736 10.369 25.7553 10.6491 25.7757 11.0778C25.7782 11.1255 25.7757 11.1732 25.7757 11.2209L25.7989 11.2253ZM14.3564 23.7315L14.3796 23.7283C14.4941 22.724 14.6121 21.7201 14.7205 20.7156C14.7418 20.5184 14.7987 20.3677 14.9568 20.2262C17.4357 18.0068 19.9103 15.7828 22.3807 13.5543C22.4198 13.519 22.4777 13.4863 22.4898 13.4424C22.5146 13.3524 22.5143 13.2554 22.5245 13.1616C22.4405 13.1546 22.3553 13.1368 22.2729 13.1451C22.2192 13.1505 22.167 13.1905 22.1177 13.2211C21.879 13.3695 21.641 13.5179 21.4035 13.6663L13.7878 18.4451C13.4698 18.6445 13.1519 18.8448 12.8291 19.0493L14.3564 23.7315Z",
                fill: "#0A1C32"
            })
        ]
    });
};
/* harmony default export */ var Menu_TelegramIcon = (TelegramIcon);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
;// CONCATENATED MODULE: ./src/components/Menu/XIcon.tsx

var XIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6899 35.9391C27.4599 35.9391 35.3799 28.019 35.3799 18.2491C35.3799 8.47917 27.4599 0.559082 17.6899 0.559082C7.92002 0.559082 -6.10352e-05 8.47917 -6.10352e-05 18.2491C-6.10352e-05 28.019 7.92002 35.9391 17.6899 35.9391Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_5_230)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.5851 16.9371L26.1438 9.48047H24.0569L22.7417 10.9685L18.6552 15.6165L14.7447 10.0648L14.3333 9.48049H8.718L15.5362 19.1611L8.63373 27.0122H10.7209L16.4657 20.4809L20.6575 26.4328L21.0692 27.0166H26.6844L25.2443 24.9715L19.5851 16.9371ZM19.4208 17.1238L19.422 17.1225L25.0004 25.0425L26.2266 26.7838H26.2246L24.9989 25.0431V25.043L19.4208 17.1238ZM18.4921 18.1795L23.6054 25.4394H21.9263L17.5586 19.238L17.5607 19.2356L16.6308 17.9156L16.6287 17.918L11.7968 11.0574H13.4758L17.5623 16.8596L17.562 16.8599L18.4918 18.1797L18.4921 18.1795ZM18.491 15.8034L14.5408 10.1953L14.2018 9.71387H9.17618L9.17575 9.71327H14.2034L18.4921 15.8022L18.491 15.8034ZM25.6201 9.71387H24.1742L22.9325 11.1187L18.7989 15.8205L18.7968 15.8175L22.9285 11.1181L24.1702 9.71325H25.6207L25.6201 9.71387ZM18.6336 16.0032L18.6326 16.0044L18.6346 16.0073L18.6357 16.0061L18.6336 16.0032ZM16.324 20.2797L10.6072 26.7794H10.6038L16.3226 20.2777L16.324 20.2797ZM17.3944 19.4248L21.7949 25.6729V25.6728H24.0617L24.0612 25.6722H21.7964L17.3954 19.4236L17.3944 19.4248ZM17.2538 19.2226L17.2528 19.2238L17.2512 19.2216L17.2523 19.2204L17.2538 19.2226ZM16.4656 18.1035L11.3394 10.8252H11.3375L16.4645 18.1049L16.4656 18.1035Z",
                    fill: "#0A1C32"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_5_230",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(8.68994 9.24908)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Menu_XIcon = (XIcon);

;// CONCATENATED MODULE: ./src/components/Menu/YoutubeIcon.tsx

var YoutubeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.0099 35.0593C27.5369 35.0593 35.2601 27.3362 35.2601 17.8092C35.2601 8.28222 27.5369 0.559082 18.0099 0.559082C8.48296 0.559082 0.759827 8.28222 0.759827 17.8092C0.759827 27.3362 8.48296 35.0593 18.0099 35.0593Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.0048 13.5668C26.9035 13.1617 26.697 12.7907 26.4063 12.491C26.1156 12.1913 25.751 11.9736 25.3492 11.86C23.8814 11.5015 18.01 11.5015 18.01 11.5015C18.01 11.5015 12.1385 11.5015 10.6707 11.8941C10.2689 12.0078 9.90429 12.2254 9.6136 12.5251C9.3229 12.8248 9.11644 13.1959 9.01506 13.6009C8.74642 15.0906 8.61502 16.6017 8.6225 18.1154C8.61292 19.6405 8.74434 21.1632 9.01506 22.6641C9.12682 23.0565 9.33791 23.4135 9.62793 23.7005C9.91795 23.9875 10.2771 24.1949 10.6707 24.3026C12.1385 24.6952 18.01 24.6952 18.01 24.6952C18.01 24.6952 23.8814 24.6952 25.3492 24.3026C25.751 24.1889 26.1156 23.9713 26.4063 23.6716C26.697 23.3719 26.9035 23.0008 27.0048 22.5958C27.2714 21.1173 27.4028 19.6177 27.3974 18.1154C27.407 16.5903 27.2756 15.0676 27.0048 13.5668Z",
                fill: "#0A1C32",
                stroke: "#0A1C32",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0898 20.906L20.9969 18.1154L16.0898 15.3248V20.906Z",
                fill: "white",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Menu_YoutubeIcon = (YoutubeIcon);

// EXTERNAL MODULE: ./src/components/Svg/ArrowIcon.tsx
var ArrowIcon = __webpack_require__(71515);
;// CONCATENATED MODULE: ./src/views/Home_v2/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 32px;\n  padding-left: 160px;\n  padding-right: 160px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 32px;\n    margin-top: 32px;\n    @media only screen and (max-width: 768px) {\n      flex-direction: column;\n      gap: 32px;\n    }\n\n    .text-gradient {\n      font-weight: 800;\n      font-size: 72px;\n      background: linear-gradient(90deg, #00ebc9 0%, #00b6f6 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n    .left {\n      display: flex;\n      flex-direction: column;\n      align-items: start;\n      gap: 32px;\n      justify-content: center;\n\n      @media only screen and (max-width: 768px) {\n        align-items: center;\n      }\n    }\n    .trade-btn {\n      width: 172px;\n      height: 63px;\n      border-radius: 8px;\n      border: 2px;\n      opacity: 0px;\n      background: #ffffff;\n      color: #0e1420;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      font-size: 16px;\n      cursor: pointer;\n    }\n  }\n\n  @media (max-width: 1025px) {\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 630px;\n  margin: 0 auto 48px;\n  background: rgb(255, 255, 255, 0.6);\n\n  border: 1px solid rgb(218 220 223);\n  border-radius: 4px;\n  .head {\n    padding: 24px 16px;\n    border-bottom: 1px solid #383e48;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    ",
        " {\n      padding: 24px;\n    }\n\n    h1 {\n      font-weight: 700;\n      font-size: 20px;\n      line-height: 140%;\n      text-align: center;\n      color: #ffffff;\n      margin-bottom: 8px;\n    }\n\n    p {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 140%;\n      text-align: center;\n      color: #f98c36;\n    }\n  }\n\n  .content {\n    padding: 24px 16px;\n\n    ",
        " {\n      padding: 24px;\n    }\n\n    .btn-max {\n      color: #f98c36;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 19px;\n\n      display: flex;\n      align-items: center;\n      text-align: center;\n      justify-content: center;\n\n      width: 63px;\n      height: 27px;\n      margin-left: 10px;\n      background: #111b1e;\n      border: unset;\n      box-shadow: -2px -2px 2px #1e3238, inset 0px -2px 1px #001015;\n      border-radius: 8px;\n      cursor: pointer;\n\n      ",
        " {\n        font-size: 16px;\n      }\n    }\n\n    .wrap-input-item {\n      > div > div:last-child {\n        width: 100%;\n      }\n      /* margin-bottom: 12px;\n      ",
        " {\n        margin-bottom: 32px;\n      } */\n    }\n  }\n  .form-action {\n    width: 100%;\n    margin-top: 32px;\n    button {\n      width: 100%;\n      height: 44px;\n      font-size: 14px;\n      background: #f0b90b;\n      // box-shadow: -2px -2px 2px #1e3238, inset 0px -2px 1px #001015;\n      border-radius: 8px;\n\n      ",
        " {\n        font-size: 16px;\n      }\n    }\n\n    button:disabled {\n      background: #e0e0eb;\n      color: rgb(143, 155, 179);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 12px;\n\n  min-width: 50px;\n  height: 36px;\n\n  background: transparent;\n  box-shadow: none;\n  border-radius: 8px;\n  border: unset;\n  cursor: pointer;\n\n  ",
        " {\n    height: 44px;\n    padding: 4px 16px;\n  }\n\n  > div {\n    white-space: nowrap;\n\n    > svg {\n      width: 1px;\n      path {\n        stroke: #000;\n      }\n      ",
        " {\n        width: auto;\n      }\n    }\n  }\n\n  .wIcon {\n    margin-right: 6px;\n    width: 24px;\n    height: 24px;\n\n    ",
        " {\n      width: 20px;\n      height: 20px;\n    }\n\n    > img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    > svg {\n      width: 100%;\n    }\n  }\n  .jPoDQE {\n    width: 15px;\n    height: 15px;\n    opacity: 0.5;\n    ",
        " {\n      width: 15px;\n      height: 15px;\n    }\n\n    > img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    > svg {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > div {\n    margin-bottom: 12px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .network-item {\n    align-items: center;\n    border: 0;\n    /* background: transparent; */\n    color: ",
        ";\n    cursor: pointer;\n    display: flex;\n    font-size: 16px;\n    height: 48px;\n    justify-content: space-between;\n    outline: 0;\n    padding-left: 16px;\n    padding-right: 16px;\n    width: 100%;\n\n    background: #000000;\n    border-radius: 12px;\n\n    &:hover:not(:disabled) {\n      background-color: ",
        ";\n    }\n\n    &:active:not(:disabled) {\n      opacity: 0.85;\n      transform: translateY(1px);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n  .curr-item {\n    align-items: center;\n    border: 0;\n    /* background: transparent; */\n    color: ",
        ";\n    cursor: pointer;\n    display: flex;\n    font-size: 16px;\n    height: 48px;\n    justify-content: space-between;\n    outline: 0;\n    padding-left: 16px;\n    padding-right: 16px;\n    width: 100%;\n\n    background: #edf1f7;\n    border-radius: 12px;\n\n    &:hover:not(:disabled) {\n      // background-color: ",
        ";\n    }\n\n    &:active:not(:disabled) {\n      opacity: 0.85;\n      transform: translateY(1px);\n      // background-color: ",
        ";\n    }\n\n    img {\n      width: 28px;\n      height: 28px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var StyledHome = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9616cc0-0"
})(_templateObject());
var CardBridgeTransfer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9616cc0-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var RightInputButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9616cc0-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var NetworkSelectContentStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9616cc0-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
});
var CurrenciesSelectContentStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9616cc0-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
});

;// CONCATENATED MODULE: ./src/views/Home_v2/index.tsx
/* eslint-disable lodash/import-scope */ // import { useAllBlockchain } from 'state/home/fetchAllBlockChain'
// import {useWeb3React} from '../../../packages/wagmi/src/useWeb3React'
// import TransactionBridge from './components/TransactionBridge'
// eslint-disable-next-line lodash/import-scope

function Home_v2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    Home_v2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_v2_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 22px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  justify-content: center;\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n  }\n"
    ]);
    Home_v2_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Home_v2_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  padding-top: 200px;\n  margin-left: 300px;\n  @media (min-width: 768px) {\n    padding-top: 300px;\n  }\n  @media (max-width: 500px) {\n    width: 170px;\n    padding-top: 275px;\n    margin-left: 250px;\n  }\n"
    ]);
    Home_v2_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Home_v2_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  min-width: 375px;\n  min-height: 586px;\n"
    ]);
    Home_v2_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5f079fa-0"
})(Home_v2_templateObject());
var BottomLinkGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5f079fa-1"
})(Home_v2_templateObject1());
var Styled04 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5f079fa-2"
})(Home_v2_templateObject2());
var Styled03 = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a5f079fa-3"
})(Home_v2_templateObject3());
var Home = function(param) {
    var pageSupportedChains = param.pageSupportedChains;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHome, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    fontSize: "72px",
                                    fontWeight: 800
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gradient",
                                        children: "Ting"
                                    }),
                                    " Whales"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    color: "#FFFFFF99"
                                },
                                children: "Trade like a pro with advanced tools and features at your fingertips"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "trade-btn",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://beurl.app/FBIzZpGD",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        style: {
                                            color: "#0e1420"
                                        },
                                        children: "Trade Now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/introduction_media.png",
                            alt: "whale",
                            width: 836,
                            height: 610
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomLinkGrid, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://beurl.app/iiyQUiOe",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_TelegramIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://beurl.app/pylfXWaY",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_XIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://beurl.app/ynowSChk",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_FacebookIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://beurl.app/iXhCGayd",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_YoutubeIcon, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: 117.34,
                            background: "#D9D9D9",
                            height: 0.5,
                            marginTop: 12,
                            marginBottom: 12
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "contact@tingwhales.com"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Home_v2 = (Home);

// EXTERNAL MODULE: ./src/utils/wagmi.ts + 9 modules
var wagmi = __webpack_require__(81103);
;// CONCATENATED MODULE: ./src/pages/index.tsx



var pageSupportedChains = wagmi/* chains.map */.p5.map(function(chain) {
    return chain.id;
});
// const pageSupportedChains = process.env.NEXT_PUBLIC_NODE_ENV === 'development' ? [80001, 97, 30393, 1680] : [1, 56]
var IndexPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_v2, {
        pageSupportedChains: pageSupportedChains
    });
};
IndexPage.chains = [];
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);